import { render, staticRenderFns } from "./PlanToText.vue?vue&type=template&id=18ff1e2b&"
import script from "./PlanToText.vue?vue&type=script&lang=js&"
export * from "./PlanToText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports